import { motion } from "framer-motion";
import { QUESTIONS } from "../data/quiz";

const Pill = ({ testid, active, onClick, children }) => (
  <motion.button
    data-testid={testid}
    onClick={onClick}
    whileTap={{ scale: 0.94 }}
    className={`rounded-full border px-5 py-2.5 text-sm transition-colors ${
      active
        ? "border-aqua bg-aqua font-bold text-black shadow-[0_4px_14px_rgba(34,211,238,0.4)]"
        : "border-black/10 bg-white text-zinc-600 shadow-sm hover:border-black/30"
    }`}
  >
    {children}
  </motion.button>
);

export const QuickTaps = ({ answers, onSelect }) => (
  <div data-testid="quick-taps" className="flex flex-col gap-7">
    {QUESTIONS.map((q, qi) => (
      <motion.div
        key={q.key}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: qi * 0.06 }}
      >
        <h3 className="mb-3 text-base font-semibold text-zinc-900">{q.title}</h3>
        <div className="flex flex-wrap gap-2.5">
          {q.options.map((o) => (
            <Pill
              key={o.id}
              testid={`opt-${q.key}-${o.id}`}
              active={answers[q.key] === o.id}
              onClick={() => onSelect(q.key, o.id)}
            >
              {o.label}
            </Pill>
          ))}
        </div>
      </motion.div>
    ))}
  </div>
);
